<!-- 
<template>
  <div>
    <div id="thediv" ref="thediv" @mouseover="clearFdAd" @mouseout="starFdAd">
      <div class="text">Boost Your Occupancy! Click Here</div>
      <span @click="close">X</span>
    </div>
  </div>
</template>
<script>
var interval;
export default {
  data() {
    return {
      xPos: 300,
      yPos: 200,
      step: 1,
      delay: 8,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,

    }
 
  },


  mounted () {
    interval = setInterval(this.changePos, 10)
  },
  beforeUnmount(){
    console.log('interval',interval)
    this.clearFdAd()
  },
  methods: {
    changePos () {
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      if (this.$refs.thediv) {
        
      this.Hoffset = this.$refs.thediv.offsetHeight
      this.Woffset = this.$refs.thediv.offsetWidth
      this.$refs.thediv.style.left =
        this.xPos +
        document.body.scrollLeft +
        document.documentElement.scrollLeft +
        'px'
      this.$refs.thediv.style.top =
        this.yPos +
        document.body.scrollTop +
        document.documentElement.scrollTop +
        'px'
      if (this.yon) {
        this.yPos = this.yPos + this.step
      } else {
        this.yPos = this.yPos - this.step
      }
      if (this.yPos < 0) {
        this.yon = 1
        this.yPos = 0
      }
      if (this.yPos >= height - this.Hoffset) {
        this.yon = 0
        this.yPos = height - this.Hoffset
      }
      if (this.xon) {
        this.xPos = this.xPos + this.step
      } else {
        this.xPos = this.xPos - this.step
      }
      if (this.xPos < 0) {
        this.xon = 1
        this.xPos = 0
      }
      if (this.xPos >= width - this.Woffset) {
        this.xon = 0
        this.xPos = width - this.Woffset
      }
      }
    },
    clearFdAd () {
      clearInterval(interval)
      console.log(1111);//你要点头部有一个切换你能看到吗？
    },
    starFdAd () {
      interval = setInterval(this.changePos, 10)
    },
    close(){
      this.$refs.thediv.style.display='none'
    }
  }
}
</script>

<style>

#thediv {
  display: flex;
  justify-content: space-between;
  z-index: 100;
  position: absolute;
  top: 43px;
  left: 2px;
  height: 20px;
  width: 120px;
  background-color: red;

}
.text{
  margin-top: 5px;
}

</style> -->


<template>
    <div id="thediv" ref="thediv"  style="position: absolute; z-index: 111; left: 0; top: 0;" v-show="thedivShow" @mouseover="clearFdAd" @mouseout="starFdAd">
      <!-- <div style="cursor: pointer;text-align: right;font-size:12px;color: #999999" @click=removeClick></div> -->
      <div class="here" @click=removeClick>Boost Your Occupancy! Click Here</div>
    </div>
    
</template>

<script>
  var interval;
  export default {
    data() {
      return {
        xPos: 0,
        yPos: 0,
        xin:true,
        yin :true ,
        step: 1,
        delay: 18,
        height: 0,
        Hoffset: 0,
        Woffset: 0,
        yon: 0,
        xon: 0,
        pause: true,
        thedivShow: true,
      };
    },

    created() {
      interval = setInterval(this.changePos, this.delay)
    },
    beforeUnmount(){
    console.log('interval',interval)
    this.clearFdAd()
  },
    methods: {

      changePos() {
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if (this.$refs.thediv) {
          
        
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;

        // 滚动部分跟随屏幕滚动
        // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
        // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

        // 滚动部分不随屏幕滚动
        this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft) + "px";
        this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop) + "px";

        if (this.yon) {
          this.yPos = this.yPos + this.step;
        } else {
          this.yPos = this.yPos - this.step;
        }
        if (this.yPos < 0) {
          this.yon = 1;
          this.yPos = 0;
        }
        if (this.yPos >= (height - this.Hoffset)) {
          this.yon = 0;
          this.yPos = (height - this.Hoffset);
        }

        if (this.xon) {
          this.xPos = this.xPos + this.step;
        } else {
          this.xPos = this.xPos - this.step;
        }
        if (this.xPos < 0) {
          this.xon = 1;
          this.xPos = 0;
        }
        if (this.xPos >= (width - this.Woffset)) {
          this.xon = 0;
          this.xPos = (width - this.Woffset);
        }
      }
      },
      clearFdAd() {
        clearInterval(interval)
      },
      starFdAd() {
        interval = setInterval(this.changePos, this.delay)
      },
      removeClick(){
        this.$router.push('/new');
        // this.thedivShow = false
      },
  }
}
</script>

<style lang="scss" scoped>

  #thediv {

    z-index: 100;
    position: absolute;
    top: 43px;
    left: 2px;
    // height: 184px;
    // width: 280px;
  //   height: 10px;
  // width: 30px;
  // background-color: red;
  }
  .here{
    text-align: center;
    height:100px;
    width: 600px;
    line-height: 100px;
    font-size: 30px;
    color: #fff;
    background-color: #444198;
    border-radius: 5px;
  }
  </style>


